import React from 'react';
import { motion } from 'framer-motion';
import { FlameIcon } from 'lucide-react';
const TOTAL_SPOTS = 100;
const SPOTS_LEFT = 7;
export function ScarcityBar() {
  const pct = (TOTAL_SPOTS - SPOTS_LEFT) / TOTAL_SPOTS * 100;
  return <div className="w-full max-w-xl" data-id="element-54" data-mp="2l4ej40qp4qit">
      <div className="flex items-center justify-between gap-3 text-sm font-bold" data-id="element-55" data-mp="2q40vk7ypa2qk">
        <span className="flex items-center gap-1.5 text-white" data-id="element-56" data-mp="2q1o6zbyfsu4j">
          <FlameIcon className="h-4 w-4 text-alert" aria-hidden="true" data-id="element-57" data-mp="2b5yq1s83z76o" />
          Only <span className="text-brand" data-id="element-58" data-mp="2g638vowhoe02">{SPOTS_LEFT} spots left</span> at the promotional price
        </span>
        <span className="shrink-0 text-alert" data-id="element-59" data-mp="2273myp0d2d7l">{Math.round(pct)}%</span>
      </div>
      <div className="mt-2 h-5 w-full overflow-hidden rounded-full border border-line bg-panel2" role="progressbar" aria-valuenow={Math.round(pct)} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-60" data-mp="274d8vuojk6qo">
        <motion.div className="bar-stripes h-full rounded-full bg-alert" initial={{
        width: '60%'
      }} whileInView={{
        width: `${pct}%`
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-61" data-mp="33mmu2ryk25uj" />
      </div>
      <p className="mt-1.5 text-xs text-muted" data-id="element-62" data-mp="38dlcbx33te0f">When the remaining spots are gone, the price returns to normal.</p>
    </div>;
}